// src/assets/configure-standard-actions.js
// Configure les actions standard Shopify updateCart et openCart avant les
// scripts d'apps (ADR 0002). Script classique, sans defer ni import, chargé
// juste avant content_for_header : seule la première configuration d'une
// action compte.
// Il délègue au module d'actions du bundle (js/services/StandardActions.js),
// exposé par main.js sous window.themeStandardActions et cherché à chaque
// appel : le bundle, un module, s'exécute après ce script. Sans bundle, il
// reproduit le comportement par défaut de Shopify, que toute configuration
// désactive : écriture puis rechargement pour updateCart, page panier pour
// openCart.
(() => {
  const getThemeActions = () => window.themeStandardActions;

  // Repli sans bundle, comme le runtime Shopify : un seul rechargement, une
  // fois toutes les écritures en cours réglées, si l'une d'elles a abouti
  let pendingWrites = 0;
  let reloadRequested = false;
  const reloadWhenIdle = () => {
    if (!reloadRequested || pendingWrites > 0) return;
    setTimeout(() => {
      if (!reloadRequested || pendingWrites > 0) return;
      reloadRequested = false;
      window.location.reload();
    });
  };

  const configurations = {
    updateCart: {
      // null : les events partent du document
      eventTarget: (meta) =>
        getThemeActions()?.updateCart.eventTarget(meta) ?? null,
      handler: async (defaultHandler, ...args) => {
        const themeActions = getThemeActions();
        if (themeActions) {
          return themeActions.updateCart.handler(defaultHandler, ...args);
        }

        pendingWrites += 1;
        try {
          const result = await defaultHandler();
          reloadRequested = true;
          return result;
        } finally {
          pendingWrites -= 1;
          reloadWhenIdle();
        }
      },
    },
    openCart: {
      handler: (defaultHandler, ...args) => {
        const themeActions = getThemeActions();
        return themeActions
          ? themeActions.openCart.handler(defaultHandler, ...args)
          : defaultHandler();
      },
    },
  };

  const configure = () => {
    const actions = window.Shopify?.actions;
    if (!actions) return;

    Object.entries(configurations).forEach(([name, configuration]) => {
      if (!actions[name].configure(configuration)) {
        console.warn(
          `Standard actions: ${name} est déjà configurée, la configuration du thème est ignorée`
        );
      }
    });
  };

  // Les actions sont créées par un module en fin de page : elles n'existent
  // qu'au DOMContentLoaded, sauf si le runtime a déjà tourné
  if (window.Shopify?.actions) {
    configure();
  } else {
    document.addEventListener("DOMContentLoaded", configure, { once: true });
  }
})();
